import axios from "axios";
import Constant from "../utils/constant";
// const HRMS_BASE_URL = "http://localhost:1051/hrms/";
const HRMS_BASE_URL = `${Constant.BASE_URL}hrms/`; // Use this line in production

// Create axios instance with HRMS authentication
const createHrmsAxios = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  return axios.create({
    baseURL: HRMS_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Employee Data APIs
export const getEmployeeData = async (employeeId) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/viewEmployee", {
      id: employeeId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching employee data:", error);
    throw error;
  }
};
export const downloadDocument = async (documentKey, fileName) => {
  try {
    if (!documentKey) {
      throw new Error("Document key is required");
    }

    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/downloadDocument", {
      documentKey: documentKey,
      fileName: fileName,
    });

    if (response.data.status === 1) {
      // Trigger download by opening the signed URL
      const link = document.createElement("a");
      link.href = response.data.downloadUrl;
      link.setAttribute("download", fileName || "document");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return response.data;
    } else {
      throw new Error(response.data.message || "Failed to download document");
    }
  } catch (error) {
    console.error("Error downloading document:", error);
    throw error;
  }
};
// Attendance APIs
export const getEmployeeAttendance = async (page = 1, limit = 10) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.get("/getEmployeeAttendance", {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching attendance data:", error);
    throw error;
  }
};

export const getAttendanceByMonth = async (month) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.get("/attendance-by-month", {
      params: { month },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching monthly attendance:", error);
    throw error;
  }
};

// Leave APIs
export const getRequestedLeaves = async (page = 1, limit = 10) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/requestedLeaves", {
      page,
      limit,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching requested leaves:", error);
    throw error;
  }
};

// New Leave Module APIs
export const applyLeave = async (leaveData) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/leaves/apply", leaveData);
    return response.data;
  } catch (error) {
    console.error("Error applying leave:", error);
    throw error;
  }
};

export const getMyLeaves = async (pageOrOptions = 1, limitArg = 10) => {
  try {
    const hrmsAxios = createHrmsAxios();

    let params = {};
    if (typeof pageOrOptions === "object") {
      const { page = 1, limit = 10, employeeId } = pageOrOptions || {};
      params = { page, limit };
      if (employeeId) {
        params.employeeId = employeeId;
      }
    } else {
      params = { page: pageOrOptions, limit: limitArg };
    }

    const response = await hrmsAxios.get("/leaves/my-leaves", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching my leaves:", error);
    throw error;
  }
};

export const getMyLeaveBalance = async (yearOrOptions = undefined) => {
  try {
    const hrmsAxios = createHrmsAxios();

    let params = {};
    if (typeof yearOrOptions === "object") {
      const { year = new Date().getFullYear(), employeeId } =
        yearOrOptions || {};
      params.year = year;
      if (employeeId) {
        params.employeeId = employeeId;
      }
    } else {
      const year = yearOrOptions || new Date().getFullYear();
      params.year = year;
    }

    const response = await hrmsAxios.get("/leaves/balance", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching leave balance:", error);
    throw error;
  }
};

export const getTeamLeaveRequests = async (
  page = 1,
  limit = 10,
  status = "Pending"
) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.get("/leaves/team-requests", {
      params: { page, limit, status },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching team leave requests:", error);
    throw error;
  }
};

export const approveLeaveRequest = async (leaveId, comment = "") => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.put(`/leaves/approve/${leaveId}`, {
      comment,
    });
    return response.data;
  } catch (error) {
    console.error("Error approving leave:", error);
    throw error;
  }
};

export const rejectLeaveRequest = async (leaveId, comment = "") => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.put(`/leaves/reject/${leaveId}`, {
      comment,
    });
    return response.data;
  } catch (error) {
    console.error("Error rejecting leave:", error);
    throw error;
  }
};

export const getLeaveTypes = async (page = 1, limit = 10) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/listLeave", {
      page,
      limit,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching leave types:", error);
    throw error;
  }
};

// Payroll APIs
export const getEmployeePayroll = async (page = 1, limit = 10) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/getEmployeePayroll", {
      page,
      limit,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching payroll data:", error);
    throw error;
  }
};

export const viewPayslip = async (employeeId, month, year) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.get("/viewPayslip", {
      params: { employeeId, month, year },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching payslip:", error);
    throw error;
  }
};

// Department and Manager APIs
export const getDepartments = async () => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/listDepartment");
    return response.data;
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export const getManagers = async () => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.get("/listManager");
    return response.data;
  } catch (error) {
    console.error("Error fetching managers:", error);
    throw error;
  }
};

// Dashboard Statistics Helper Functions
export const getDashboardStats = async (employeeId) => {
  try {
    // Get current month attendance
    const currentMonth = new Date().toISOString().slice(0, 7); // YYYY-MM format
    const attendanceData = await getAttendanceByMonth(currentMonth);

    // Get requested leaves
    const leavesData = await getRequestedLeaves(1, 10);

    // Calculate statistics
    const stats = {
      attendanceThisMonth: attendanceData?.data?.length || 0,
      totalWorkingDays: 26, // This should be calculated based on working days in the month
      leaveBalance: 12, // This should come from employee data
      pendingLeaves:
        leavesData?.data?.filter((leave) => leave.status === "Pending")
          ?.length || 0,
      approvedLeaves:
        leavesData?.data?.filter((leave) => leave.status === "Approved")
          ?.length || 0,
      totalHoursWorked:
        attendanceData?.data?.reduce(
          (total, day) => total + (day.hours_worked || 8),
          0
        ) || 0,
    };

    return stats;
  } catch (error) {
    console.error("Error calculating dashboard stats:", error);
    throw error;
  }
};

export const getTeamEmployees = async (page = 1, limit = 20) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/getEmployeeList", {
      page,
      limit,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching team employees:", error);
    throw error;
  }
};

export const getPendingLeaveRequests = async (page = 1, limit = 20) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/requestedLeaves", { page, limit });
    return response.data;
  } catch (error) {
    console.error("Error fetching pending leave requests:", error);
    throw error;
  }
};
// src/services/hrms.service.js

// You might have other functions here, e.g.:
// export const getEmployeeDetails = async (employeeId) => { /* ... */ };
export const updateLeaveStatus = async ({ id, status, managerRemarks }) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/updateLeaveStatus", {
      id,
      status, // Expected values: 'Approved' | 'Rejected'
      managerRemarks: managerRemarks || "",
    });
    return response.data;
  } catch (error) {
    console.error("Error updating leave status:", error);
    throw error;
  }
};

// Holiday APIs
// Get holidays list (for all roles: HR, Manager, Employee)
export const getHolidays = async (year = null, page = 1, limit = 10) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const currentYear = year || new Date().getFullYear();
    const response = await hrmsAxios.get("/holidays", {
      params: { year: currentYear, page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching holidays:", error);
    throw error;
  }
};

// Add holiday (HR only)
export const addHoliday = async (holidayData) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.post("/holidays", holidayData);
    return response.data;
  } catch (error) {
    console.error("Error adding holiday:", error);
    throw error;
  }
};

// Update holiday (HR only)
export const updateHoliday = async (holidayId, holidayData) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.put(`/holidays/${holidayId}`, holidayData);
    return response.data;
  } catch (error) {
    console.error("Error updating holiday:", error);
    throw error;
  }
};

// Delete holiday (HR only)
export const deleteHoliday = async (holidayId) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.delete(`/holidays/${holidayId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting holiday:", error);
    throw error;
  }
};

// Team Members API
export const getTeamMembers = async (page = 1, limit = 10) => {
  try {
    const hrmsAxios = createHrmsAxios();
    const response = await hrmsAxios.get("/leaves/team-members", {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching team members:", error);
  }
};
export default {
  getEmployeeData,
  getEmployeeAttendance,
  getAttendanceByMonth,
  getRequestedLeaves,
  // leave module new
  applyLeave,
  getMyLeaves,
  getMyLeaveBalance,
  getTeamLeaveRequests,
  approveLeaveRequest,
  rejectLeaveRequest,
  getLeaveTypes,
  getEmployeePayroll,
  viewPayslip,
  getDepartments,
  getManagers,
  getDashboardStats,
  // manager helpers
  getTeamEmployees,
  getPendingLeaveRequests,
  updateLeaveStatus,
  // holiday APIs
  getHolidays,
  addHoliday,
  updateHoliday,
  deleteHoliday,
};
